import ApiService from "../api";

export default class FortesFiscalService extends ApiService {

    constructor() {
        super('/api/fortes/ac')
    }

    conciliacaoDeSaldos(params) {
        return this.get(`/conciliacao?dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}&codigoEmpresa=${params.codigoEmpresa}&conta=${params.conta}`)
    }

    relatorio(params) {
        return this.get(`/conciliacao/relatorios?dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}&codigoEmpresa=${params.codigoEmpresa}&conta=${params.conta}`)
    }

    exportConciliacaoDeSaldos(params) {
        return this.getFile(`/conciliacao/exportar?dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}&codigoEmpresa=${params.codigoEmpresa}&conta=${params.conta}`)
    }

    buscarEmpresas() {
        return this.get(`/empresas`)
    }

    buscarEmpregadoCargo(params) {
        const queryParams = new URLSearchParams();

        if (params.empCodigo) queryParams.append("empCodigo", params.empCodigo);
        if (params.nome) queryParams.append("nome", params.nome);
        if (params.ativos !== undefined) queryParams.append("ativos", params.ativos);

        // Suporte a múltiplos cargos
        if (params.cargos && Array.isArray(params.cargos)) {
            params.cargos.forEach(cargo => {
                queryParams.append("cargos", cargo);
            });
        }

        return this.get(`/empregados?${queryParams.toString()}`);
    }

    exportListaEmpregados(params) {
        const queryParams = new URLSearchParams();

        if (params.empCodigo) queryParams.append("empCodigo", params.empCodigo);
        if (params.nome) queryParams.append("nome", params.nome);
        if (params.ativos !== undefined) queryParams.append("ativos", params.ativos);

        // Suporte a múltiplos cargos
        if (params.cargos && Array.isArray(params.cargos)) {
            params.cargos.forEach(cargo => {
                queryParams.append("cargos", cargo);
            });
        }

        return this.getFile(`/empregados/exportar?${queryParams.toString()}`);
    }

    sincronizarFuncionariosFortes() {
        return this.get(`/funcionarios`);
    }

    buscarEventosFolha(params) {
        const queryParams = new URLSearchParams();

        if (params.empresaCodigo) queryParams.append("empresaCodigo", params.empresaCodigo);
        if (params.estabelecimentoCodigo) queryParams.append("estabelecimentoCodigo", params.estabelecimentoCodigo);
        if (params.eventos !== undefined) queryParams.append("eventos", params.eventos);
        if (params.anoMes !== undefined) queryParams.append("anoMes", params.anoMes);

        return this.get(`/eventos-folhas?${queryParams.toString()}`);
    }

    buscarEventos(empresaCodigo) {
        const params = new URLSearchParams();

        if (empresaCodigo) params.append("empresaCodigo", empresaCodigo);
        return this.get(`/eventos?${params}`);
    }

    buscarDadosDesligamento(funcionarioId) {
        const params = new URLSearchParams();
        params.append("funcionarioId", funcionarioId);
        return this.get(`/desligamento?${params}`);
    }
}